<template>
  <div>
    <div style="height: 100%;">
      <a 
        v-if="step>0"
        href="https://wa.me/34622859056"
        target="_blank"
        class="position-fixed bg-white py-2 px-3"
        style="z-index: 1000 !important;border-radius: 1000px; bottom: 4rem; right: 2rem;">
        <i class="fs-2 fa-brands fa-whatsapp text-success"></i>
      </a>
      <div 
        v-if="step==0"
        class="w-100"
        style="height: 100%;background-color: #f5f5f5; position: fixed; z-index: 10000 !important">
        <div class="w-100 h-100 position-absolute top-0 d-flex align-items-center ">
          <div 
            style="color:rgb(1, 22, 56);"
            class="px-5 text-center fw-semibold">
            <h2>👋</h2>
            <h2 
              class="mb-4 fw-bold" 
              style="font-size:2.5rem">¡Hola, Driver!</h2>
            <p 
              style="font-size:1.2rem"
              class="mb-4 fw-light">Completa el formulario para saber dónde y en qué horario necesitas aparcar.</p>
            <!--<h4 class="mb-4 fw-bold">¡Estás en el sitio correcto!</h4>-->
            <div class="fw-light mb-3">
              <p
                class="fw-bold"
                style="font-size:1.1rem">
                ⚠️ ️Recibirás en tu correo las plazas que encajen contigo.
              </p>
              <a 
                href="https://wa.me/34622859056"
                target="_blank"
                class="text-decoration-none fw-light"
                style="font-size:1.1rem; color: rgb(1, 22, 56)">
                Si tienes dudas durante el proceso, estamos aquí para ayudarte 
                <i class="ms-2 fs-3 fa-brands fa-whatsapp text-success"></i>
              </a>
              <p
                class="fw-semibold mt-3"
                style="font-size:1.1rem">
                Empieza hoy a aparcar sin estrés con Parkiduo.
              </p>
            </div>
            <button
              class="btn py-2 w-100 rounded-3 mt-4"
              style="background-color: #011638; font-size: 1.1rem;font-weight: 700; color: white"
              @click="step++; trackMixPanel('apphomedriver_click_empezar')"
            >
              <span>EMPEZAR</span>
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="step<5"
        id="folding_tab"
        class="px-4"
        :class="{ collapsed: isCollapsed }"
      >
        <div 
          class="pt-2"
          style="height: 45px;">
          <div class="stepper-wrapper">
            <div class="stepper">
              <div 
                :class="step>1 ? '' : 'opacity-0'" 
                class="step-container">
                <div class="step completed"></div>
                <div class="step-label">{{ steps_names[step-1] }}</div>
              </div>
              <div class="step-container">
                <div class="step active"></div>
                <div class="step-label">{{ steps_names[step] }}<br><span class="fw-bold">{{ step }}/4</span></div>
              </div>
              <div 
                :class="step<4 ? '' : 'opacity-0'"
                class="step-container">
                <div class="step"></div>
                <div class="step-label">{{ steps_names[step+1] }}</div>
              </div>
            </div>
            <!-- Líneas entre pasos -->
            <div
              :class="step>1 ? '' : 'opacity-0'" 
              class="line line-1"></div>
            <div 
              :class="step<4 ? '' : 'opacity-0'"
              class="line line-2"></div>
          </div>
        </div>
        <div>
          <div 
            v-if="step==1">
            <div class="mb-0 mt-4 ">
              <i
                class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                style="color:#011638; border-radius: 1000px; "
                @click="step--"
              />
              <span
                style="color:#011638; font-size: 0.8rem;"
                class="ms-3 mb-1 fw-semibold ms-2"
              >UBICACIÓN</span>
            </div>
            <div
              style="height: calc(100vh - 155px);">
              <address-browser-component
                text="Indica tu dirección de búsqueda"
                text2="Buscaremos garajes a máximo 10 minutos andando de tu ubicación"
                title=" "
                :is_parker="false"
                @get-data-address="handleGetAddress"
                @address-selected="trackMixPanel('applocationdriver_click_searchresults')"
                @clicked-icon="trackMixPanel('applocationdriver_click_icon')"
                :address="this.input.address"
              />
            </div>
          </div>
          <div
            v-else-if="step==2"
            class=""
            style="display: flex; flex-direction: column; height: 100%;"
          >
            <div style="flex-grow: 1; overflow: auto;">
              <div class="m-0 mt-4 ">
                <i
                  class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                  style="color:#011638; border-radius: 1000px; "
                  @click="step--"
                />
                <span
                  style="color:#011638; font-size: 0.8rem;"
                  class="ms-3 mb-1 fw-semibold ms-2"
                >HORARIO DE APARCAMIENTO</span>
              </div>
              <!--
              <div class="row m-0 mt-3">
                <div class="col">
                  <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                    <i
                      class="fa-solid fa-location-dot me-2"
                      style="font-size: 1.2rem;"
                    />
                    UBICACIÓN
                  </span>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ input.address.street }}
                  </p>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ input.address.city }}
                  </p>
                </div>
              </div>-->
              <div
                class="row m-0 mt-2"
                style="color:#011638"
              >
                <div class="row m-0 bg-white rounded-top-4 py-3">
                  <span class="col">Lunes a viernes </span>
                  <div class="form-check form-switch col-2 d-flex justify-content-end">
                    <input
                      id="flexSwitchCheckDefault"
                      v-model="weekdays"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    >
                  </div>
                </div>
                <div
                  v-if="!full_day && weekdays"
                  class="row m-0 bg-white py-3 ps-4"
                >
                  <span class="col">Franja horaria</span>
                  <time-component
                    ref="time_component"
                    class="col"
                    :es-deshabilitado="full_day"
                    @get-data-horas="handleGetDataHoras"
                  />
                </div>
              </div>
              <div
                v-if="weekdays"
                class="row m-0 bg-white rounded-bottom-4 py-3 ps-4 pe-2 "
              >
                <span class="col">Día entero (24h)</span>
                <div class="form-check form-switch col-2 d-flex justify-content-end me-1">
                  <input
                    id="flexSwitchCheckDefault"
                    v-model="full_day"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                  >
                </div>
              </div>
              <div
                class="row m-0 mt-2"
                style="color:#011638"
              >
                <p
                  style="color:#56647A"
                  class="mb-1"
                />
                <div class="row m-0 bg-white rounded-3 py-3">
                  <span class="col">Sábado y domingo (24h)</span>
                  <div class="form-check form-switch col-2 d-flex justify-content-end">
                    <input
                      id="flexSwitchCheckDefault"
                      v-model="input.weekend_full_day"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    >
                  </div>
                </div>
              </div>
              <p
                v-if="hour_error"
                class="text-danger text-center mt-3"
              >
                Introduce un horario correcto
              </p>
            </div>
            <div
              style="height: 50px;"
              class="mt-3"
            >
              <button
                class="btn py-2 w-100 rounded-3"
                style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
                @click="((weekdays || input.weekend_full_day) && (input.time.startTime != '--:--') && input.time.endTime != '--:--') ? (step++, hour_error = false,trackMixPanel('apptimedriver_click_siguiente')) : (hour_error = true)"
              >
                <span>Siguiente <i
                  class="fa-solid fa-angle-right ms-1"
                  style="font-size: 1rem;"
                /></span>
              </button>
            </div>
          </div>
          <div
            v-else-if="step==3"
            class=""
            style="display: flex; flex-direction: column; height: 100%;"
          >
            <div
              style="flex-grow: 1; overflow-y: auto; overflow-x: hidden;"
            >
              <div class="m-0 mt-4 ">
                <i
                  class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                  style="color:#011638; border-radius: 1000px; "
                  @click="step--; $nextTick(() => { if ($refs.time_component) { $refs.time_component.CambiarHoras(input.time); } })"
                />
                <span
                  style="color:#011638; font-size: 0.8rem;"
                  class="ms-3 mb-1 fw-semibold ms-2"
                >VEHÍCULO</span>
              </div>
              <!--
              <div class="row m-0 mt-3">
                <div class="col">
                  <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                    <i
                      class="fa-solid fa-location-dot me-2"
                      style="font-size: 1.2rem;"
                    />
                    UBICACIÓN
                  </span>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ formattedStreet }}
                  </p>
                  <p
                    class="mb-0"
                    style="color:#011638"
                  >
                    {{ input.address.city }}
                  </p>
                </div>
                <div class="col">
                  <span style="color:#56647A;font-size: 0.9rem; font-weight: 600;">
                    <i
                      class="fa-regular fa-clock me-2"
                      style="font-size: 1.2rem;"
                    />
                    HORARIO
                  </span>
                  <p
                    v-if="input.time.startTime"
                    class="mb-0"
                    style="color:#011638"
                  >
                    L-V
                    <span v-if="input.time.startTime == '00:00' && input.time.endTime == '00:00'">
                      24h
                    </span>
                    <span v-else>{{ input.time.startTime }}h - {{ input.time.endTime }}h</span>
                  </p>
                  <p
                    v-if="input.weekend_full_day"
                    class="mb-0"
                    style="color:#011638"
                  >
                    S-D 24h
                  </p>
                </div>
              </div>-->
              <!--<div 
                style="cursor:pointer"
                class="mt-3 bg-white ps-3 rounded-4">
                <div
                  class="row m-0"
                  @click="input.vehicle_size='small'"
                >
                  <p
                    class="py-3 mb-0 col-10"
                    style="color:#8E97A7"
                  >
                    Coche pequeño (3,6 x 1,6m)
                  </p>
                  <i
                    v-if="input.vehicle_size=='small'"
                    class="fa-solid fa-check col-2 d-flex align-items-center"
                    style="color:#011638"
                  />
                </div>
                <hr class="my-0">
                <div
                  class="row m-0"
                  @click="input.vehicle_size='medium'"
                >
                  <p
                    class="py-3 mb-0 col-10"
                    style="color:#8E97A7"
                  >
                    Coche mediano (4,5 x 1,8m)
                  </p>
                  <i
                    v-if="input.vehicle_size=='medium'"
                    class="fa-solid fa-check col-2 d-flex align-items-center"
                    style="color:#011638"
                  />
                </div>
                <hr class="my-0">
                <div
                  class="row m-0"
                  @click="input.vehicle_size='large'"
                >
                  <p
                    class="py-3 mb-0 col-10"
                    style="color:#8E97A7"
                  >
                    Coche grande (5,0 x 1,9m)
                  </p>
                  <i
                    v-if="input.vehicle_size=='large'"
                    class="fa-solid fa-check col-2 d-flex align-items-center"
                    style="color:#011638"
                  />
                </div>
              </div>-->
              <div 
                style="cursor:pointer"
                class="mt-3 bg-white p-3 rounded-4">
                <div
                  class="d-flex mx-2 me-4 mt-2"
                >
                  <p class="ps-2 text-start mb-0">
                    Tamaño
                  </p>
                  <div 
                    class="flex-grow-1"
                    style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                    <p 
                      v-if="formattedSize?.length>0"
                      class="text-black text-end mb-0">Coche {{ formattedSize }}</p>
                  </div>
                  <div
                    style="color:#15E0DD" 
                    class="nav-item dropdown-toggle">
                    <a
                      style="color:#15E0DD"
                      data-bs-toggle="dropdown"
                      href="#"
                      role="button"
                      aria-expanded="false"
                    >
                      <i class="fa-solid fa-car ms-2" />
                    </a>
                    <ul class="dropdown-menu">
                      <li @click="input.vehicle_size='small'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Pequeño (3,6 x 1,6m)</a>
                      </li>
                      <li @click="input.vehicle_size='medium'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Mediano (4,5 x 1,8m)</a>
                      </li>
                      <li @click="input.vehicle_size='large'">
                        <a
                          class="dropdown-item"
                          href="#"
                        >Grande (5,0 x 1,9m)</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <hr>
                <div class="d-flex align-items-center mx-3 m-0">
                  <p 
                    class="text-start mb-0 me-3 flex-shrink-0" 
                    style="white-space: nowrap;">
                    Modelo de coche
                  </p>
                  <input
                    id="floatingInput"
                    v-model="input.vehicle_model"
                    class="form-control border-0 py-1 px-0 text-end bg-transparent flex-grow-1"
                    placeholder="Seat Ibiza..."
                  >
                </div>
                <hr>
                <div class="d-flex justify-content-between align-items-center mx-3">
                  <span class="pe-2">Vehículo eléctrico</span>
                  <div class="form-check form-switch d-flex justify-content-end">
                    <input
                      id="flexSwitchCheckDefault"
                      v-model="input.electric_car"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    >
                  </div>
                </div>
              </div>
              <p
                v-if="error"
                class="text-danger text-center mt-3"
              >
                Debe seleccionar un tamaño
              </p>
            </div>
            <div
              style="height: 50px;"
              class="mt-3"
            >
              <button
                class="btn py-2 w-100 rounded-3"
                style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
                @click="input.vehicle_size != null ? (step++, trackMixPanel('appsizedriver_click_siguiente')) : error=true"
              >
                <span>
                  Siguiente
                  <i
                    class="fa-solid fa-angle-right ms-1"
                    style="font-size: 1rem;"
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="step==4"
          style="background-color: #F5F6F8;width: 100%;"
        >
          <div>
            <div class="pt-3">
              <div class="m-0 mt-2 ">
                <i
                  class="fa-solid fa-angle-left px-2 py-1 text-center bg-white"
                  style="color:#011638; border-radius: 1000px; "
                  @click="step--"
                />
                <span
                  style="color:#011638; font-size: 0.8rem;"
                  class="ms-3 mb-1 fw-semibold ms-2"
                >INFORMACIÓN ADICIONAL</span>
              </div>
              <!--
              <div
                class="bg-white rounded-4 p-3 my-3"
                style="color:#011638"
              >
                <div
                  class="d-flex justify-content-between align-items-center "
                  @click="open_drawer(1)"
                >
                  <p class="mb-0 pe-2">
                    Ubicación
                  </p>
                  <p
                    class="mb-0 text-end truncated-text"
                    style="color:#15E0DD;"
                  >
                    {{ formattedStreet }}
                    <i class="fa-solid fa-location-dot ms-2" />
                  </p>
                </div>
                <hr>
                <div
                  class="d-flex justify-content-between align-items-center "
                  @click="open_drawer(2)"
                >
                  <p class="mb-0 pe-2">
                    Horario
                  </p>
                  <p
                    class="text-end mb-0 truncated-text"
                    style="color:#15E0DD"
                  >
                    <span v-if="input.time.startTime">
                      L-V
                    </span>
                    <span v-if="input.time.startTime == '00:00' && input.time.endTime == '00:00'">
                      24h
                    </span>
                    <span v-else-if="input.time.startTime">{{ input.time.startTime }}h - {{ input.time.endTime }}h</span>
                    <span v-if="input.weekend_full_day"> S-D 24</span>
                    <i class="fa-regular fa-clock ms-2" />
                  </p>
                </div>
                <hr>
                <div
                  class="d-flex justify-content-between align-items-center "
                  @click="open_drawer(3)"
                >
                  <p class="mb-0 pe-2">
                    Tamaño
                  </p>
                  <p
                    class="text-end mb-0"
                    style="color:#15E0DD"
                  >
                    {{ formattedSize }} <i class="fa-solid fa-up-right-and-down-left-from-center ms-2" />
                  </p>
                </div>
              </div>-->
              <div
                class="bg-white rounded-4 p-3 my-3"
                style="color:#011638"
              >
                <div
                  class="d-flex justify-content-between align-items-center "
                >
                  <p class="mb-0 pe-2">
                    Periodo de alquiler
                  </p>
                  <div class="">
                    <div class="nav-item dropdown w-100">
                      <a
                        class="nav-link dropdown-toggle w-100 text-end"
                        style="color:#15E0DD"
                        data-bs-toggle="dropdown"
                        href="#"
                        role="button"
                        aria-expanded="false"
                      >
                        {{ formattedPeriod }}
                        <i class="fa-regular fa-calendar ms-2" />
                      </a>
                      <ul class="dropdown-menu">
                        <li @click="input.duration='1-6months'">
                          <a
                            class="dropdown-item"
                            href="#"
                          >1-6 meses</a>
                        </li>
                        <li @click="input.duration='6months'">
                          <a
                            class="dropdown-item"
                            href="#"
                          >6-12 meses</a>
                        </li>
                        <li @click="input.duration='indefinite'">
                          <a
                            class="dropdown-item"
                            href="#"
                          >Indefinido</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <p
                class="mb-1 fw-semibold ms-2"
                style="color:#56647A; font-size: 0.8rem;"
              >
                COMENTARIOS
              </p>
              <div
                class="bg-white rounded-4 p-3 mb-2"
                style="color:#011638"
              >
                <textarea
                  v-model="input.comments"
                  class="form-control border-0 mx-0 p-0 col"
                  placeholder="Otros comentarios que quieras añadir"
                  style="min-height: 30px;"
                />
              </div>
              <span
                v-if="form_error"
                class="text-danger px-3"
              >
                Rellena los campos obligatorios (*)
              </span>
              <span
                v-if="creation_error"
                class="text-danger px-3"
              >
                Error al crear el driver
              </span>
              <button
                class="btn py-2 w-100 rounded-3 my-3"
                style="background-color: #011638; font-size: 1.1rem;font-weight: 500; color: white"
                @click="save_driver"
              >
                <span>Registrar solicitud de Garaje</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="completed"
        style="height: calc(100% - 80px);"
        class="d-flex align-items-center"
      >
        <div class="w-100">
          <div class="w-100 d-flex mb-5 justify-content-center">
            <img
              src="@/assets/checked-register.png"
              alt="Email enviada"
              class="img-fluid"
            >
          </div>
          <h3
            class="text-center mb-3 fw-bold mx-3"
            style="color:#394A64"
          >
            ¡Gracias por tu registro!
          </h3>
          <p
            style="color:#56647A"
            class="mx-3 text-center"
          >
            Recibirás en tu correo las plazas compatibles contigo. Esperamos que encuentres pronto tu garaje. ¡Suerte!
          </p>
        </div>
      </div>
      <div
        v-if="completed"
        style="height: 50px;"
        class="mx-3 mb-3"
      >
        <button
          class="btn py-2 w-100 rounded-3"
          style="background-color: #15E0DD; font-size: 1.1rem;font-weight: 600; color: #011638"
          @click="close"
        >
          <span>Cerrar</span>
        </button>
      </div>
    </div>
    <drawer
      v-if="step==4"
      ref="drawer"
      :input="input"
      :weekdays="weekdays"
      :full_day="full_day"
      :is_parker="false"
      :individual_step="true"
      @get-data-input="handleGetInput"
    />
    <drawer-login
      v-if="step==4"
      ref="drawer_login"
      :is_driver="true"
      @login-completed="/*this.trackMixPanel('USUARIO LOGUEADO'),*/save_driver"
      @confirm-mail="this.trackMixPanelLogin('appconfirmpersonaldatadriver_click_confirmar', false)"
      @confirm-personal-data="this.trackMixPanelLogin('appconfirmpersonaldatadriver_click_confirmar', true)"
    />
    <spinner-component
      id="spinner"
      class="d-none"
      style="z-index: 100;"
    />
  </div>
</template>
<script>
  import axios from 'axios';
  import SpinnerComponent from '../components/SpinnerComponent.vue'
  import TimeComponent from '../components/TimeComponent.vue'
  
  import AddressBrowserComponent from '../components/AddressBrowserComponent.vue';
  import { mapState } from 'vuex';
  //import router from '@/router';
  import noPhoto from './../assets/default.jpg';
  import Drawer from '../components/Drawer.vue';
  import DrawerLogin from '../components/DrawerLogin.vue';
  import { formatSize, formatPeriod } from '../services/traslation';
  import mixpanel from 'mixpanel-browser';

  export default {
    name: 'CreateDriver',
    components:{
        SpinnerComponent,
        TimeComponent,
        AddressBrowserComponent,
        Drawer,
        DrawerLogin
    },
    data: function() {
      return {
        isCollapsed: false,
        step: 0,
        add_tag: "",
        input: {
            address: {},
            time: {
              startTime: "--:--",
              endTime: "--:--"
            },
            weekend_full_day: false,
            vehicle_size: null,
            type:null,
            electric_car: false,
            duration: "1-6months"
        },
        full_day: false,
        weekdays: true,
        error: null,
        noPhoto,
        hour_error: false,
        default_tags: ["Facíl maniobra", "Puerta automática", "Apertura con móvil", "Montacargas", "Ascensor peatonal", "Cámaras de seguridad", "Personal de seguridad", "Caragdor eléctrico"],
        completed: false,
        form_error: false,
        creation_error: false,
        steps_names: [ "", "Ubicación", "Horario", "Tamaño", "Información"]
      }
    },
    computed: {
      ...mapState(['isLoggedIn']),
      ...mapState(['token']),
      formattedSize() {
        return formatSize(this.input.vehicle_size);
      },
      formattedPeriod(){
        return formatPeriod(this.input.duration)
      },
      formattedStreet() {
      return this.input.address.street.length > 15 ? this.input.address.street.slice(0, 15) + "..." : this.input.address.street;
    }
    },
    mounted(){
    },
    watch:{
        weekdays(){
          if(this.weekdays){
            console.log("AQUII", this.input.time)
            this.input.time.startTime=this.input.time.startTime ?? "--:--"
            this.input.time.endTime=this.input.time.endTime ?? "--:--"
          }else{
            this.input.time.startTime="--:--"
            this.input.time.endTime="--:--"
            this.full_day = false
          }
          this.$nextTick(() => { if (this.$refs.time_component) { this.$refs.time_component.CambiarHoras(this.input.time); } })
        },
        full_day(){
          if(this.full_day){
            this.input.time.startTime="00:00"
            this.input.time.endTime="00:00"
          }else{
            this.input.time.startTime="--:--"
            this.input.time.endTime="--:--"
          }
          this.$nextTick(() => { if (this.$refs.time_component) { this.$refs.time_component.CambiarHoras(this.input.time); } })
        },
        async step(){
          switch(this.step){
            case 1:{
                await this.$nextTick();
                this.isCollapsed=false;
                break;
            }
            case 2:
                this.isCollapsed=false;
                break;
            case 3:
                this.isCollapsed=false;
                break;
            case 4:
                this.isCollapsed=false;
                break;
          }
        }
    },
    methods:{
      trackMixPanel(mensaje){
        mixpanel.track(mensaje, {
          pantalla: 'Create Driver'
        });
      },
      trackMixPanelLogin(mensaje, isNewUser){
        let userType = isNewUser ? 'newUser' : 'existing';
        mixpanel.track(mensaje, {
          pantalla: 'Create Driver',
          userType: userType
        });
      },
      close() {
        window.open("https://parkiduo.com", "_blank");
        },
      handleGetInput(input){
        this.input.address = input.address
        this.weekdays = input.time.startTime!=null ? true : false
        this.input.time = input.time
        this.full_day = input.time.startTime == "00:00" && input.time.endTime == "00:00" ? true : false
        this.input.weekend_full_day = input.weekend_full_day
        this.input.vehicle_size = input.vehicle_size
      },
      open_drawer(step){
        this.$refs.drawer.openDrawer()
        this.$refs.drawer.change_step(step)
      },
      async handleGetAddress(address){
        //this.isCollapsed = true;
        this.input.address.street = address.street
        this.input.address.zip_code = address.zip_code || ""
        this.input.address.state = address.state
        this.input.address.address = address.address
        this.input.address.center = address.center
        this.input.address.city = address.city
        
        //await this.$nextTick();
        //this.update_map()

        this.step = 2
        this.trackMixPanel('applocationdriver_click_confirmar ubicación')
        this.$nextTick(() => { if (this.$refs.time_component) { this.$refs.time_component.CambiarHoras(this.input.time); } })
      },
        handleGetDataHoras(time){
          this.input.time = time
        },
        async save_driver(){
          this.trackMixPanel('appparametersdriver_click_registrar solicitud de garaje')

          if(!this.input.duration){
            this.form_error = true
            //this.trackMixPanel("appparametersdriver_click_registrar_driver error")
            return
          }

          if(!this.isLoggedIn){
            this.$refs.drawer_login.openDrawer()
            return
          }

          var spinner = document.getElementById("spinner")
          spinner.classList.remove("d-none")

          try{

            let startMinutes = null
            let endMinutes = null

            if(this.weekdays){
              if(this.full_day){
                startMinutes = 0
                endMinutes = 0
              }
              else {
                const [startHour, startMinute] = this.input.time.startTime.split(":").map(Number);
                startMinutes = startHour * 60 + startMinute;

                const [endHour, endMinute] = this.input.time.endTime.split(":").map(Number);
                endMinutes = endHour * 60 + endMinute;
              }
            }


            const body = {
              location: {
                latitude: this.input.address.center[0],
                longitude: this.input.address.center[1]
              },
              address: {
                street: this.input.address.street,
                city: this.input.address.city,
                state: this.input.address.state,
                zip_code: this.input.address.zip_code,
              },
              vehicle_size: this.input.vehicle_size,
              weekend_full_day: this.input.weekend_full_day,
              start_hour: startMinutes,
              end_hour: endMinutes,
              electric_car: this.input.electric_car,
              vehicle_model: this.input.vehicle_model,
              period: this.input.duration,
              comments: this.input.comments
            }

            await axios.post(process.env.VUE_APP_API_URL + '/api/user_preferences/',
              body,{
              headers: {
                'Authorization': `Bearer ${this.token}`
                },}
            )

            const message = {
              content: '¡NUEVO DRIVER! Mensaje desde el front',
            };

            this.send_discord(message)

            this.step=5
            this.trackMixPanel('appcompletedriver_registrar solicitud de garaje')
            const message2 = {
              content: '¡Enviado a MIXPANEL DRIVER CREADO! Mensaje desde el front',
            };
            this.send_discord(message2)
            this.completed=true

            spinner.classList.add("d-none")

          }catch(error){
            console.log("ERROR en la creacion")
            this.creation_error = true

            const message = {
              content: '¡ERROR creando DRIVER! Mensaje desde el front' + error.message,
            };
            this.send_discord(message)

            spinner.classList.add("d-none")
          }
        },
        send_discord(message){
          const webhookURL = 'https://discord.com/api/webhooks/1352418917892489328/9TiZ2q07JPG5YnwA11Fpt3oAPKxMLqBw1TxZHsP5bkMxi7Nj1ywDY6edfMp47CNuNSxv';

          fetch(webhookURL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(message),
          });
        }
    }
  }
</script>
<style scoped>

.form-check-input{
    height: 20px !important;
}

.el-select__wrapper{
    padding: 0px;
    margin: 0px;
}



  .tab{
    height: 5px;
    margin-top: 10px;
    width: 13%;
    background-color: #AAB1BD;
    border-radius: 100px;
  }

  #folding_tab{
    background-color: #F5F6F8 !important;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    transition: height 0.5s ease;
    z-index: 100;
    position: absolute;
    width: 100%;
    overflow-x:hidden
  }

  #folding_tab.collapsed {
        height: 60vh;
        bottom: 0 !important;
    }

    #map {
        height: calc(100% + 30px) !important;
        width: 100%;
        z-index: 0 !important
    }


    .form-check-input:checked {
        background-color: #15E0DD;
        border-color: #15E0DD;
    }

    .truncated-text {
      white-space: nowrap;        /* Evita saltos de línea */
      overflow: hidden;           /* Oculta el texto que se pase */
      text-overflow: ellipsis;    /* Agrega "..." al final si es muy largo */
      max-width: 100%;            /* Asegura que no crezca más allá del col-6 */
      display: block;             /* Asegura que respete los estilos de ancho */
    }

    .form-control:focus {
      outline: none !important;  /* Elimina el contorno azul de Bootstrap */
      box-shadow: none !important;  /* Quita el resplandor */
      border: none !important;  /* Elimina el borde */
    }

    .etiqueta{
      background-color: #F5F6F8;
      border: 1px solid #E3E5E9;
      margin-right: 10px;
      padding: 4px 10px 4px 10px;
      border-radius: 5px;
      margin-bottom: 10px;
    }

    .selected_tag{
      background-color: #B7F7F5;
      border: 1px solid #011638;
    }

    .stepper-wrapper {
        position: relative;
        width: 100%;
        max-width: 500px;
      }

      .stepper {
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 2;
      }

      .step-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        position: relative;
        width: 60px;
      }

      .step {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #ccc;
        border: 2px solid #ccc;
        z-index: 2;
      }

      .step.completed {
        background-color: #011638;
        border-color: #011638;
      }

      .step.active {
        background-color: white;
        border: 3px solid #011638;
      }

      .step-label {
        font-size: 12px;
        color: #555;
      }

      /* Líneas */
      .line {
        position: absolute;
        top: 10px; /* altura media de las bolitas (20px / 2) */
        height: 1px;
        background-color: #ccc;
        z-index: 1;
      }

      .line-1 {
        left: calc(60px / 2);
        right: calc(100% / 3 + 60px / 2);
      }

      .line-2 {
        left: calc(100% / 3 + 60px / 2);
        right: calc(60px / 2);
      }

</style>
